import RecordsUser from "./records-user";

/** Шапка таблицы записей */
const RecordsHeader = ({users, height, timeWidth, userWidth, records, onResize }) => {

  const divHeader = [
    <div style={{width: timeWidth, height: height }} key={0}>Время</div>,
    ...users.map((item, index) => (
      <div key={item.id} style={{width: userWidth, height: height, position: 'relative'}}>
        <RecordsUser 
          user={item} 
          height={height} 
          width={userWidth} 
          qty={records.filter(i => i.userId === item.id).length} 
          onResize={onResize}
        />
        {index > 0 && <div className="records-resize-handle" onMouseDown={onResize} />}
      </div>
    ))
  ]

  return<div className="records-header">{divHeader}</div>
}

export default RecordsHeader;